import { Card, DataDisplay, Grid, pn, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { User, UserViewResource } from "generated/openApi";
import { useDateTime } from "hooks";
import "moment-timezone";
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import { BackgroundColor } from "devextreme-react/chart";

export const SystemInfo = (props: { user: User; setUser: (value: User) => void; viewResource: UserViewResource }) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];
  const formatDateTime = useDateTime();

  const createdField = () => {
    var propertyName = pn<User>("createdDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.createdDate)}</DataDisplay>;
  };

  const registeredDateField = () => {
    var propertyName = pn<User>("registeredDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.registeredDate)}</DataDisplay>;
  };

  const passwordChangedDateField = () => {
    var propertyName = pn<User>("lastPasswordChangedDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>{formatDateTime(props.user.lastPasswordChangedDate)}</DataDisplay>
    );
  };

  const passwordExpirationDateField = () => {
    var propertyName = pn<User>("passwordExpirationDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.passwordExpirationDate)}</DataDisplay>;
  };

  const lastLoginDateField = () => {
    var propertyName = pn<User>("lastLoginDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.lastLoginDate)}</DataDisplay>;
  };

  const lastLockedDateField = () => {
    var propertyName = pn<User>("lastLockedDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.lastLockedDate)}</DataDisplay>;
  };

  return (
    <Card transparentHeader={true} header={
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <SettingsSuggestOutlinedIcon></SettingsSuggestOutlinedIcon>
          <Typography variant="inherit" paddingLeft={"5px"}>System</Typography>
        </Stack>
      </Stack>
    }>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {createdField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {registeredDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {passwordChangedDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {passwordExpirationDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {lastLoginDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {lastLockedDateField()}
        </Grid>
      </Grid>
    </Card>
  );
};
